import { RpcClient } from "../client";

export const rpcClient = new RpcClient((data) =>
  window.sendMessage("rpcRequest", data)
);

window.rpcClient = rpcClient;
